import Grid from '@mui/material/Grid2';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import AnalysisFilterViewModel from "../ViewModels/AnalysisFilterViewModel";
import { useContext, useEffect, useState } from 'react';
import { APIContext } from '../../Contexts/APIContext';

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function SurveyYears({ state, updateState }: IProps) {
    const { post } = useContext(APIContext);
    const [startYears, setStartYears] = useState<number[]>([]);
    const [endYears, setEndYears] = useState<number[]>([]);
    const [latestSurveyYear, setLatestSurveyYear] = useState<number | null>(null);

    useEffect(() => {
        let active = true;
        setLatestSurveyYear(null);

        post(
            "TimeSlice",
            "GetLatestSurveyYear",
            state,
            (response: number | null) => {
                if (!active) return;

                setLatestSurveyYear(response);

                if (response == null) return;

                updateState({
                    endYear: response,
                    startYear: Math.min(state.startYear, response - 4),
                });
            }
        );

        return () => {
            active = false;
        };
    }, [state.landUseMain, state.landUseSub]);

    const handleChange = (event: SelectChangeEvent<number>) => {
        var value = Number.parseInt(event.target.value as string)

        switch (event.target.name) {
            case "startYear":
                updateState({
                    startYear: value,
                })
                break;
            case "endYear":
                updateState({
                    endYear: value,
                })
                break;
        }
    }

    useEffect(() => {
        if (latestSurveyYear == null) {
            setStartYears([]);
            setEndYears([]);
            return;
        }

        let startYears: number[] = []
        for (var i = 1980; i <= Math.min(state.endYear, latestSurveyYear) - 4; i++) {
            startYears.push(i)
        }

        let endYears: number[] = [];
        for (var i = state.startYear + 4; i <= latestSurveyYear; i++) {
            endYears.push(i)
        }

        setStartYears(startYears)
        setEndYears(endYears)
    }, [state.startYear, state.endYear, latestSurveyYear])

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Grid container size={6}>
                <Typography>Start Year</Typography>
                <Grid size={12}>
                    <Select
                        name="startYear"
                        value={state.startYear}
                        onChange={handleChange}>
                        {startYears
                            .filter(f => state.mode == 0 || f >= 2000)
                            .map((x: number) => {
                                return <MenuItem key={x} value={x}>
                                    {x}
                                </MenuItem>;
                            }
                            )}
                    </Select>
                </Grid>
            </Grid>
            <Grid container size={6}>
                <Typography>End Year</Typography>
                <Grid size={12}>
                    <Select
                        name="endYear"
                        value={state.endYear}
                        onChange={handleChange}>
                        {endYears.map((x: number) => {
                            return <MenuItem key={x} value={x}>
                                {x}
                            </MenuItem>;
                        }
                        )}
                    </Select>
                </Grid>
            </Grid>
        </Grid>
    )
}
